import { ADMIN_PREFERENCE_CACHE_KEYS } from '@/shared/constants/cache-keys'

export interface AdminPreferenceStorage {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
}

const getStorage = (): AdminPreferenceStorage | null => {
  return typeof localStorage === 'undefined' ? null : localStorage
}

export const readAdminSidebarCollapsed = (
  storage: AdminPreferenceStorage | null = getStorage()
): boolean => {
  return storage?.getItem(ADMIN_PREFERENCE_CACHE_KEYS.sidebarCollapsed) === '1'
}

export const writeAdminSidebarCollapsed = (
  collapsed: boolean,
  storage: AdminPreferenceStorage | null = getStorage()
): void => {
  storage?.setItem(ADMIN_PREFERENCE_CACHE_KEYS.sidebarCollapsed, collapsed ? '1' : '0')
}
